export default __webpack_public_path__ + "static/media/northern_lights.84bf9a5c.jpeg";